import { Box, Icon } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import ReceiveTokenTab from "./ReceiveTokenTab";
import TransferTokenWrapper from "./TransferTokenWrapper";
import BuyTokensWrapper from "./BuyTokensWrapper";
import { buyTokenPopUpContext } from "../../context/buyTokenPopUpContext";
import environmentVariables from "../../config/environmentVariables";
import { truncateNumberBalance } from "../../config/common";
import swapicon from '../../Images/Icons/swapicon.png'
import recieveicon from '../../Images/Icons/recieveicon.png'
import sendicon from '../../Images/Icons/sendicon.png'
import buyicon from '../../Images/Icons/buyicon.png'
import SwapTokensWrapper from "./SwapTokensWrapper";

const TokenIcon      = `${environmentVariables?.cdnUrl}mldtokenicon.png`
const LordTokenIcon  = `${environmentVariables?.cdnUrl}lordtokenicon.png`
const MaticTokenIcon = `${environmentVariables?.cdnUrl}matictokenicon.png`
const usdtTokenIcon  = `${environmentVariables?.cdnUrl}usdticonupdated.png`
const Root = styled.div``;

const style = {
  position: "absolute",
  top: "50.5%",
  left: "1.5%",
  height: "102vh",
  transform: "translate(-10%, -50%)",
  width: 400,
  bgcolor: "#1a1c1f",
  border: "2px solid #000",
  boxShadow: 24,
  borderRadius: "0px",
  padding: "32px",
  // overflowY: "visible",
  overflowY: "scroll",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  "@media (max-width: 1000px)": {
    left: "3%",
  },
  "@media (max-width: 600px)": {
    left: "10%",
    width:"100vw",
    padding:"45px 32px 32px 20px"
  },

  

  "@media (max-height: 480px)" : {
    width: "100vw",
    transform: "translate(0, -50%)",
    left: "10%",
    padding: "10px 30px !important",
  },
};
const TextWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
`;
const Mldlandscape = styled.div`

  @media (max-height: 480px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
const Text = styled.div`
  font-size: 22px;
  font-weight: bold;
  font-family: "SweraDemo";
  padding: 10px 0;
`;
const Tokenstripwrapper = styled.div`
  background-color: #212327;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 10px 15px;
  border-radius: 8px;
  margin: 15px 0;
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
`;
const TokenContainer = styled.div``;
const ImageTextWrapper = styled.div`
  display: flex;
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 30px;
  height: 30px;
  background-color: none;
  border-radius: 25px;
  padding-left: 5px;
`;
const Image = styled.img`
  width: 35px;
`;
const TokenTextWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 0 15px;
`;
const TokenText = styled.text`
  font-size: 16px;
  font-weight: 400;
  font-family: "SweraDemo";
  color: white;
`;
const Tokenpricewrapper = styled.div`
  font-size: 18px;
  font-weight: 400;
  font-family: "SweraDemo";
  display: flex;
  flex-direction: column;

  text-align: center;
  align-items: end;
`;
const Tokenprice = styled.div`
  font-size: 20px;
  font-weight: 600;
  font-family: '"sans serif"';
  color: white;
`;

const ButtonBox=styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const ButtonText = styled.div`
font-size: 16px;
color: white;
font-weight: 400;
margin-top: 8px;
`

const ButtonWrapper = styled.div`
  width: 100%;
  margin: 25px 0 2rem 0;
  display: flex;
  justify-content: center;
  /* background-color: rgba(33, 35, 39, 0.8); */
  border-radius: 10px;
  @media (max-width: 768px) {
    padding: 0 10px;
  }
  `;

  const IconWrapper= styled.div`
  `

  const Icons=styled.img``

const Button = styled.button`
  border: none;
  padding: 10px 0px;
  border-radius: 50%;
  outline: none;
  margin: 0 16px;
  font-size: 16px;
  height: 54px;
  width: 54px;
  background:rgba(255, 255, 255, 0.1);
  /* margin: 10px 0; */
  cursor: pointer;
  @media (max-height: 480px) {
    padding: 15px 32px;
  }
`;

const PopUpCloseWrapper = styled.div`
  background-color: gray;
  width: 42px;
  border-radius: 20px;
  height: 40px;
`;
const PopUpcloseWrapper = styled.div``;
const PopupCloseButton = styled.div`
  color: white;
  background-color: #212327;
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 20px;
  align-items: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
`;

const BuyNowWrapper = styled.div``;
const BuyNow = styled.button`
  width: 100%;
  background-color: rgb(146 95 146);
  color: white;
  padding: 15px 0;
  margin: 5px 0 20px 0;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
`;

const LineWrapper = styled.div`
  width: 100%;
  height: 1px;
  background-color: #605e5e;
  margin: 0 0 22px 0;
`;
const HorizontalLine = styled.div``;

export const TokenInnerPopup = ({
  open,
  setOpen,
  getInformation,
  userBalance,
  address,
  allContractDetails,
  mldTokenName,
  getUserBalance,
  maticTokenName,
  lordTokenName,
  usdtTokenName,
  checkPerDayLimit,
  isSwapsLoading,
  setIsSwapsLoading,
  userSwapsToday,
  setUserSwapsToday,
  CheckIsUserWhitelisted,
  isUserWhitelisted,
  setIsUserWhitelisted,
}) => {
  const [component, setCompotent] = useState(
    <ReceiveTokenTab address={address} />
  );
  const [selected, setSelected] = useState(0);
  const [color, setColor] = useState(["gray", "#212327"]);
  const [textcolor, setTextColor] = useState(["#fff", "#fff"]);
  const { isBuyOpen } = useContext(buyTokenPopUpContext);
  useEffect(() => {
    const params=new URLSearchParams(location.search);
    const action=params.get("action");
    if(action=="buy"){
      setCompotent(
        <BuyTokensWrapper
          allContractDetails={allContractDetails}
          mldTokenName={mldTokenName}
          maticTokenName={maticTokenName}
          lordTokenName={lordTokenName}
          usdtTokenName={usdtTokenName}
        />
      );
      setSelected(2);
    }
    if(action=='swap'&&lordTokenName){
      setCompotent(
        <SwapTokensWrapper
          allContractDetails={allContractDetails}
          mldTokenName={mldTokenName}
          maticTokenName={maticTokenName}
          lordTokenName={lordTokenName}
          usdtTokenName={usdtTokenName}
          getUserBalance={getUserBalance}
          userBalance={userBalance}
          checkPerDayLimit={checkPerDayLimit}
          isSwapsLoading={isSwapsLoading}
          setIsSwapsLoading={setIsSwapsLoading}
          userSwapsToday={userSwapsToday}
          setUserSwapsToday={setUserSwapsToday}
          CheckIsUserWhitelisted={CheckIsUserWhitelisted}
          isUserWhitelisted={isUserWhitelisted}
          setIsUserWhitelisted={setIsUserWhitelisted}
        />
      );
      setSelected(3);
    }
    if (isBuyOpen) {
      setCompotent(
        <BuyTokensWrapper
          allContractDetails={allContractDetails}
          mldTokenName={mldTokenName}
          maticTokenName={maticTokenName}
          lordTokenName={lordTokenName}
          usdtTokenName={usdtTokenName}
        />
      );
      setSelected(2);
    }
  }, [isBuyOpen]);
  function clickHandler(event) {
    if (event === "ReceiveToken") {
      setCompotent(<ReceiveTokenTab address={address} />);
      setSelected(0);
      // setColor(["gray", "transparent"]);
      // setTextColor(["#fff", "gray"]);
    } else if (event === "buy") {
      setCompotent(
        <BuyTokensWrapper
          allContractDetails={allContractDetails}
          mldTokenName={mldTokenName}
          maticTokenName={maticTokenName}
          lordTokenName={lordTokenName}
          usdtTokenName={usdtTokenName}
        />
      );
      setSelected(2);
      // setColor(["transparent", "gray"]);
      // setTextColor(["gray", "#fff"]);
    } else if (event === "swaptoken"){
      setCompotent(
        <SwapTokensWrapper
          allContractDetails={allContractDetails}
          mldTokenName={mldTokenName}
          maticTokenName={maticTokenName}
          lordTokenName={lordTokenName}
          getUserBalance={getUserBalance}
          usdtTokenName={usdtTokenName}
          userBalance={userBalance}
          checkPerDayLimit={checkPerDayLimit}
          isSwapsLoading={isSwapsLoading}
          setIsSwapsLoading={setIsSwapsLoading}
          userSwapsToday={userSwapsToday}
          setUserSwapsToday={setUserSwapsToday}
          CheckIsUserWhitelisted={CheckIsUserWhitelisted}
          isUserWhitelisted={isUserWhitelisted}
          setIsUserWhitelisted={setIsUserWhitelisted}
          />
      )
      setSelected(3)
    } else {
      setCompotent(
        <TransferTokenWrapper
          mldTokenName={mldTokenName}
          maticTokenName={maticTokenName}
          lordTokenName={lordTokenName}
          usdtTokenName={usdtTokenName}
          getUserBalance={getUserBalance}
          getInformation={getInformation}
          allContractDetails={allContractDetails}
          userBalance={userBalance}
        />
      );
      setSelected(1);
      // setColor(["transparent", "gray"]);
      // setTextColor(["gray", "#fff"]);
    }
  }

  function getTheBalance() {
    if (mldTokenName) {
      return truncateNumberBalance(userBalance?.MLDBalanceDec , 2);
    }
    if (lordTokenName) {
      return truncateNumberBalance(userBalance?.LORD , 2);
    }
    if (maticTokenName) {
      return truncateNumberBalance(userBalance?.MATIC , 4);
    }
    if (usdtTokenName) {
      return truncateNumberBalance(userBalance?.USDT , 4);
    }
  }
  return (
    <Root>
      <Box sx={style}>
        
        <Mldlandscape>
          <PopUpcloseWrapper>
            <PopupCloseButton onClick={() => setOpen(false)}>
              <i class="fa-solid fa-angle-left"></i>
            </PopupCloseButton>
          </PopUpcloseWrapper>
          <TokenContainer>
            <Tokenstripwrapper>
              <ImageTextWrapper>
                <ImageWrapper>
                  <Image
                    src={
                      mldTokenName
                        ? TokenIcon
                        : maticTokenName
                        ? MaticTokenIcon
                        : lordTokenName
                        ? LordTokenIcon
                        : usdtTokenName
                        ? usdtTokenIcon
                        : ""
                    }
                  />
                </ImageWrapper>
                <TokenTextWrapper>
                  <TokenText>
                    {mldTokenName && "$MLD"}
                    {maticTokenName && "POL"}
                    {lordTokenName && "$LORD"}
                    {usdtTokenName && "USDT (POLYGON)"}
                  </TokenText>
                </TokenTextWrapper>
              </ImageTextWrapper>
              <Tokenpricewrapper>
                <Tokenprice>{getTheBalance()}</Tokenprice>
                {/* <Tokenprice>$0</Tokenprice> */}
              </Tokenpricewrapper>
            </Tokenstripwrapper>
          </TokenContainer>
        </Mldlandscape>
        {/* <BuyNowWrapper>
        <BuyNow> Buy Now </BuyNow>
      </BuyNowWrapper> */}

        <LineWrapper>
          <HorizontalLine></HorizontalLine>
        </LineWrapper>
<div>{component}</div>
        <ButtonWrapper>
         <ButtonBox>
           <Button
            style={selected==0?{border:"1px solid #25a8c5"}:{border:"none"}}
            onClick={() => clickHandler("ReceiveToken")}
          >
            <IconWrapper>
              <Icons src={recieveicon}/>
            </IconWrapper>
          </Button>
          <ButtonText>
            Receive
          </ButtonText>
         </ButtonBox>

          <ButtonBox>
            <Button
            style={selected==1?{border:"1px solid #25a8c5"}:{border:"none"}}
            onClick={() => clickHandler("TransferToken")}
          >
             <IconWrapper>
              <Icons src={sendicon}/>
            </IconWrapper>
          </Button>
          <ButtonText>
            Send
          </ButtonText>
          </ButtonBox>
         <ButtonBox>
           <Button
            style={selected==2?{border:"1px solid #25a8c5"}:{border:"none"}}
            onClick={() => clickHandler("buy")}
          >
             <IconWrapper>
              <Icons src={buyicon}/>
            </IconWrapper>
          </Button>
          <ButtonText>
            Buy
          </ButtonText>
         </ButtonBox>
          {lordTokenName&&<ButtonBox>
             <Button
             style={selected==3?{border:"1px solid #25a8c5"}:{border:"none"}}
             disabled={maticTokenName||usdtTokenName||mldTokenName}
            onClick={() => clickHandler("swaptoken")}
          >
             <IconWrapper>
              <Icons src={swapicon}/>
            </IconWrapper>
          </Button>
          <ButtonText>
            Swap
          </ButtonText>
          </ButtonBox>}
        </ButtonWrapper>

        
      </Box>
    </Root>
  );
};
